import {
    Box,
    Button,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useToast
} from "@chakra-ui/react";
import _ from "lodash";
import React from "react";
import { useParams } from "react-router-dom";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import { ICreateTimetableValues, TimetableForm } from "../../forms";
import {
    AccountDocument,
    AccountType,
    ClientProfile,
    DayOfWeek,
    DoctorProfile,
    TimeTableItem,
    useAccountQuery,
    useAddTimetableMutation
} from "../../graphql";

const daysString2Type = {
    Monday: DayOfWeek.Monday,
    Tuesday: DayOfWeek.Tuesday,
    Thursday: DayOfWeek.Thursday,
    Wednesday: DayOfWeek.Wednesday,
    Friday: DayOfWeek.Friday,
    Saturday: DayOfWeek.Saturday,
    Sunday: DayOfWeek.Sunday
};

export const Timetable: React.FC<{ clientId: number; silent?: boolean }> = ({
    clientId,
    silent
}) => {
    const toast = useToast();

    const { data: accountData, loading } = useAccountQuery({
        variables: {
            id: clientId
        }
    });
    const [update] = useAddTimetableMutation();

    const handleChange = async (data: ICreateTimetableValues) => {
        const timetable: TimeTableItem[] = [];

        Object.keys(data).forEach((day) => {
            const value = data[day];
            const item = {
                ...value,
                dayOfWeek: daysString2Type[day]
            };

            delete item.__typename;

            timetable.push(item);
        });

        try {
            await update({
                variables: {
                    id: clientId,
                    data: timetable
                },
                refetchQueries: [
                    {
                        query: AccountDocument,
                        variables: {
                            id: clientId
                        }
                    }
                ]
            });

            toast({
                description: "Ndryshimet u ruajtën me sukses."
            });
        } catch (err) {
            toast({
                description: "Pati problem në ruajtjen e ndryshimeve.",
                status: "error"
            });
        }
    };

    if (loading) {
        return <Loader />;
    }

    const timetable = (accountData?.account?.profile as DoctorProfile)?.timetable;
    const timetableFormatted = _.mapValues(
        _.groupBy(timetable, "dayOfWeek"),
        (value) => {
            return value[0];
        }
    );

    return (
        <Box
            borderWidth="1px"
            borderRadius="lg"
            overflow="hidden"
            p={ 2 }
            background="white"
        >
            <Text>
                Vendos oranin e ditëve të punës për mjekun e pëgjithshëm. Mjeku do të
                telefonohet vetëm në oraret e paracaktuara.
            </Text>
            <TimetableForm
                onSubmit={ (value) => handleChange(value) }
                initialValues={ timetableFormatted }
            />
        </Box>
    );
};
